/* ===================================================
   Holding Absence - Theme JavaScript
   =================================================== */

(function () {
  'use strict';

  /* -- Header scroll state ----------------------- */
  const header = document.querySelector('.header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 20) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -- Mobile menu toggle ------------------------ */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuIconOpen = document.querySelector('[data-menu-icon-open]');
  const menuIconClose = document.querySelector('[data-menu-icon-close]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('mobile-menu--open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      header.classList.toggle('header--menu-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';

      if (menuIconOpen && menuIconClose) {
        menuIconOpen.style.display = isOpen ? 'none' : 'block';
        menuIconClose.style.display = isOpen ? 'block' : 'none';
      }
    });
  }

  /* -- Announcement bar dismiss ------------------ */
  const announcementBar = document.querySelector('[data-announcement-bar]');
  const dismissBtn = document.querySelector('[data-announcement-dismiss]');

  if (announcementBar && dismissBtn) {
    const dismissed = sessionStorage.getItem('announcement-dismissed');
    if (dismissed === 'true') {
      announcementBar.style.display = 'none';
    }

    dismissBtn.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      sessionStorage.setItem('announcement-dismissed', 'true');
    });
  }

  /* -- Quantity selector -------------------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;

    const wrapper = btn.closest('[data-qty-wrapper]');
    const input = wrapper.querySelector('[data-qty-input]');
    if (!input) return;

    let value = parseInt(input.value, 10) || 1;
    const direction = btn.getAttribute('data-qty-btn');

    if (direction === 'minus' && value > 1) {
      value--;
    } else if (direction === 'plus') {
      value++;
    }

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* -- Add to cart (AJAX) ------------------------ */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-add-to-cart-form]');
    if (!form) return;

    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        submitBtn.textContent = 'Added!';
        updateCartCount();
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 1500);
      } else {
        const data = await response.json();
        submitBtn.textContent = data.description || 'Error';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }
    } catch (err) {
      submitBtn.textContent = 'Error';
      setTimeout(() => {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }, 2000);
    }
  });

  /* -- Update cart count badge -------------------- */
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (err) {
      // silently fail
    }
  }

  /* -- Seated widget loader ---------------------- */
  const seatedEl = document.querySelector('[data-seated-widget]');
  if (seatedEl) {
    const script = document.createElement('script');
    script.src = 'https://widget.seated.com/app.js';
    script.async = true;
    document.body.appendChild(script);
  }

  /* -- Cart page: line item quantity change ------- */
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (!input) return;

    const lineKey = input.getAttribute('data-cart-qty');
    const quantity = parseInt(input.value, 10);

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity }),
      });
      window.location.reload();
    } catch (err) {
      // silently fail
    }
  });

  /* -- Cart page: remove line item --------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;

    e.preventDefault();
    const lineKey = btn.getAttribute('data-cart-remove');

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      });
      window.location.reload();
    } catch (err) {
      // silently fail
    }
  });

  /* -- Init cart count on page load -------------- */
  updateCartCount();

})();
